var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DefaultWidget", {
    attrs: { name: "顶栏布局设置", icon: "mdi-sort" },
    on: {
      mouseover: function ($event) {
        return _vm.loadNavbarSettings()
      },
      click: function ($event) {
        return _vm.toggleNavbarSettings()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }